import _get from 'lodash/get';

export const getPagesById = state => _get(state, 'website.pages.byId', {});

export const getPagesTypeToId = state => _get(state, 'website.pages.typeToId', {});

export const getPagesOrderedIds = state => _get(state, 'website.pages.orderedIds', []);

export const getPagesByOrderedId = state =>
  getPagesOrderedIds(state).map(id => getPagesById(state)[id]);

export const getPageVisibility = (state, id) => _get(state, `website.pages.byId[${id}].hidden`);

export default {
  getPagesById,
  getPagesTypeToId,
  getPagesByOrderedId,
  getPageVisibility,
};



// WEBPACK FOOTER //
// ./src/selectors/website/pageSelectors.js